import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {TutorialPage} from './tutorial';

@NgModule({
  declarations: [
    TutorialPage,
  ],

  imports: [
    IonicModule,
    SharedModule
  ],
})
export class TutorialPageModule {
}
